<template>
  <v-container>
    <v-row>
      <!--  -->
      <template v-for="i, r in debugInfo">
        <v-col
          :key="`${i}_key`"
          cols="12"
          sm="6"
        >
          {{ r }}
        </v-col>
        <v-col
          :key="`${i}_val`"
          cols="12"
          sm="6"
        >
          {{ debugInfo[r] }}
        </v-col>
      </template>

      <!--  -->
      <v-col
        cols="12"
        sm="6"
      >
        FCM Token
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <p>{{ isPwa ? fcmToken : ' - ' }}</p>
        <v-btn @click="copyToken">
          Copy FCM Token
        </v-btn>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        Check For Updates
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-btn
          color="green"
          @click="checkForUpdates"
        >
          Check for updates
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import copy from 'copy-to-clipboard';
import { computed, ref } from 'vue';
import usePwa from '@/composables/pwa';
import store from '@/store/store';
import appVersion from '@/app-version';

const { userAgent } = window.navigator;
const { isPwa } = usePwa();

const fcmToken = computed(() => store.getters.fcmToken as string | null);

const copyToken = () => {
  if (!fcmToken.value) return;
  copy(fcmToken.value);
};

const registrationActive = ref('');
navigator.serviceWorker.getRegistration().then((r) => { registrationActive.value = r?.active?.state || ' - '; });

const debugInfo = computed(() => ({
  user_agent: userAgent,
  is_pwa: isPwa.value,
  version: `web_${appVersion}`,
  registration: registrationActive,
}));

const checkForUpdates = () => {
  navigator.serviceWorker.getRegistration().then((r) => {
    if (!r) {
      console.log('Service Worker Not Found');
      return;
    }
    r.update();
  });
};

</script>
